import React from "react";
import { connect } from "react-redux";
import { store } from "../../../redux/store";
import { selectors as routerSelectors } from "../../../redux/router";
import getLocale from "../../../utils/locales";

class CookieCat extends React.Component {
  componentDidMount() {
    this.initCookieCat();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.locale !== this.props.locale ||
      prevProps.theme !== this.props.theme
    ) {
      this.initCookieCat();
    }
  }

  initCookieCat = () => {
    const state = store.getState();
    const isNative = routerSelectors.isNative(state);
    const { theme, locale } = this.props;

    if (Fraction.Brand.Cookies.notify && !isNative) {
      //optional chaining no supported in fraction
      if (window.CookieCat && window.CookieCat.init) {
        window.CookieCat.init({
          app: "fraction",
          theme: theme,
          locale: locale.rfc
        });
      }
    }
  };

  render() {
    return null;
  }
}

const mapStateToProps = () => ({
  theme: Fraction.Brand.Theme.primary,
  locale: getLocale(i18n.getCurrentLocale())
});

export default connect(mapStateToProps)(CookieCat);
